import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import { responseError } from '@/utils/errors';
import ErrorToast from '@/components/toasts/ErrorToast';
import ArchivedToast from '@/components/toasts/ArchivedToast';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import actions from '../constants';
import UserApprovalToast from '../components/UserApprovalToast';
import UserSearchableToast from '../components/UserSearchableToast';

export function* userSearchableToast({ result }) {
  yield call(showToast, <UserSearchableToast item={result} />);
}

export function* userApprovedToast({ result }) {
  yield call(showToast, <UserApprovalToast items={result.items} />);
}

export function* userUpdateErrorToast(action) {
  yield call(showToast, <ErrorToast
    operation="actions.update"
    name={action.name}
    error={responseError(action).message}
  />);
}

export function* userArchiveToast({ items, isArchival }) {
  yield call(showToast, <ArchivedToast items={items} isArchival={isArchival} />);
}

export function* userArchiveErrorToast({ isArchival, items }) {
  yield call(showToast, <ErrorsToast operation={isArchival ? 'actions.archival' : 'actions.restore'} errors={items} />);
}

export default function* usersToasts() {
  yield takeEvery(actions.ARCHIVE_USERS_ERROR, userArchiveErrorToast);
  yield takeEvery(actions.ARCHIVE_USERS_SUCCESS, userArchiveToast);
  yield takeEvery(actions.UPDATE_USER_APPROVED_SUCCESS, userApprovedToast);
  yield takeEvery(actions.UPDATE_USER_SEARCHABLE_SUCCESS, userSearchableToast);
  yield takeEvery([actions.UPDATE_USER_APPROVED_ERROR, actions.UPDATE_USER_SEARCHABLE_ERROR], userUpdateErrorToast);
}
